"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeStampState = void 0;
var TimeStampState = /** @class */ (function () {
    function TimeStampState() {
    }
    TimeStampState.prototype.assignServerState = function (client, server) {
        client.updatedAt = server.updatedAt;
    };
    TimeStampState.prototype.hasConflict = function (client, server) {
        return client.updatedAt !== server.updatedAt;
    };
    TimeStampState.prototype.getStateFields = function () {
        return ["updatedAt"];
    };
    TimeStampState.prototype.currentState = function (currentObjectState) {
        return currentObjectState.updatedAt;
    };
    return TimeStampState;
}());
exports.TimeStampState = TimeStampState;
